import type { Modal } from '@ps/web-core-store';
import { canUseDOM } from '@ps/web-core-utils';
import { omit } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { Redirect, withRouter } from 'react-router';
import { qs } from 'url-parse';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const ModalRoute: React.FC<RouteComponentProps<object> & { modal: Modal; soft?: boolean }> = ({
  modal,
  soft = !!modal.locationState,
  staticContext = {}
}) => {
  const { path, locationState } = modal;
  const dispatch = useDispatch<Dispatch>();
  const query = useSelector(select.location.getQuery);
  const redirectTo = useSelector(select.cms.getRedirectUrl);
  const targetQuery = omit(query, ['redirectTo', 'brand']);

  useEffect(() => {
    dispatch.modal.enqueue(modal);
  });

  if (!soft && !canUseDOM) {
    staticContext.statusCode = 301;
    targetQuery.modal = path;
  }

  return (
    <Redirect
      to={{
        pathname: redirectTo,
        search: qs.stringify(targetQuery),
        state: locationState
      }}
    />
  );
};

export default withRouter(ModalRoute);
